import type React from "react";
import { Field } from "@design-system/Field/Field";
import { Input } from "@design-system/Input/Input";
import { Picker } from "@design-system/Picker/Picker.lib";
import { VariantGrid, VariantItem } from "./playgroundControls";

const FieldStage = ({ children }: { children: React.ReactNode }) => (
    <div style={{ width: 240 }}>{children}</div>
);

const statusItems = [
    { value: "ready", label: "Ready" },
    { value: "blocked", label: "Blocked" },
];

const StatusSelect = () => (
    <Picker.Select items={statusItems} defaultValue="ready" />
);

/** Literal Figma states plus the code-only accessibility and size cases. */
export const FieldPlaygroundMatrix = () => (
    <>
        <VariantGrid title="Figma variants" columns="wide">
            <VariantItem label="normal">
                <FieldStage>
                    <Field label="Business email">
                        <Input placeholder="name@company.com" />
                    </Field>
                </FieldStage>
            </VariantItem>
            <VariantItem label="optional">
                <FieldStage>
                    <Field label="Business email" optional>
                        <Input placeholder="name@company.com" />
                    </Field>
                </FieldStage>
            </VariantItem>
            <VariantItem label="tip">
                <FieldStage>
                    <Field
                        label="Business email"
                        description="Used for account notices"
                    >
                        <Input placeholder="name@company.com" />
                    </Field>
                </FieldStage>
            </VariantItem>
            <VariantItem label="error">
                <FieldStage>
                    <Field label="Business email" error="Email is required">
                        <Input placeholder="name@company.com" />
                    </Field>
                </FieldStage>
            </VariantItem>
        </VariantGrid>
        <VariantGrid title="Code-only cases" columns="wide">
            <VariantItem label="error + optional">
                <FieldStage>
                    <Field
                        label="Business email"
                        optional
                        error="Enter a valid email"
                    >
                        <Input placeholder="name@company.com" />
                    </Field>
                </FieldStage>
            </VariantItem>
            <VariantItem label="labelTooltip">
                <FieldStage>
                    <Field
                        label="Business email"
                        labelTooltip="Used to send account notices"
                    >
                        <Input placeholder="name@company.com" />
                    </Field>
                </FieldStage>
            </VariantItem>
            <VariantItem label="error replaces tip">
                <FieldStage>
                    <Field
                        label="Business email"
                        description="Used for account notices"
                        error="Email is required"
                    >
                        <Input placeholder="name@company.com" />
                    </Field>
                </FieldStage>
            </VariantItem>
            <VariantItem label='control="button" · Select'>
                <FieldStage>
                    <Field label="Status" control="button">
                        <StatusSelect />
                    </Field>
                </FieldStage>
            </VariantItem>
            <VariantItem label="disabled control">
                <FieldStage>
                    <Field label="Business email">
                        <Input defaultValue="hello@kick.co" disabled />
                    </Field>
                </FieldStage>
            </VariantItem>
            <VariantItem label="invalid without message">
                <FieldStage>
                    <Field label="Business email" invalid>
                        <Input placeholder="name@company.com" />
                    </Field>
                </FieldStage>
            </VariantItem>
            <VariantItem label='Input size="xl"'>
                <FieldStage>
                    <Field label="Business email">
                        <Input size="xl" placeholder="name@company.com" />
                    </Field>
                </FieldStage>
            </VariantItem>
        </VariantGrid>
    </>
);
